// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"a3795ee1","1345":"48cb8342","1408":"48cb8342","3603":"8f251385","4281":"c95ade09","7563":"c7683ee3"}[chunkId] + ".chunk.css";
};